/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { GET_PROJECT_FORMATS } from '../../actions/employees';

import { FAILURE, REQUEST, SUCCESS } from '../../actions/utils';

import { ICommonResponse, IDictionaryItem } from '../../api/types';

import genericReducers from '../genericReducer';

import { IReducers } from '..';

export type ProjectFormatsState = ICommonResponse<IDictionaryItem>;

const initialState = {} as ICommonResponse<IDictionaryItem>;
const generic = genericReducers<ProjectFormatsState>();
const projectFormats: IReducers<ProjectFormatsState> = {
  [GET_PROJECT_FORMATS[REQUEST]]: generic.get.request,
  [GET_PROJECT_FORMATS[SUCCESS]]: generic.get.success,
  [GET_PROJECT_FORMATS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, projectFormats);
